import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseApiService } from './base.service';
import { Observable } from 'rxjs';
import { PaginatedMessages } from '../models/paginated-messages';
import { ImprovedResponseRequest, PatchImprovedResponseRequest } from '../models/improved-response-request';

@Injectable({
  providedIn: 'root'
})
export class MessagesService extends BaseApiService {

  constructor(http: HttpClient) {
    super(http, 'messages');
  }

  getMessages(page: number = 1, limit: number = 10, sort: string = 'timestamp', order: 'asc' | 'desc' = 'desc', search?: string): Observable<PaginatedMessages> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString())
      .set('sort', sort)
      .set('order', order);
    if (search) {
      params = params.set('search', search);
    }
    return this._http.get<PaginatedMessages>(this._baseUrl, { params });
  }

  improveResponse(messageId: string, data: ImprovedResponseRequest): Observable<void> {
    return this._http.post<void>(`${this._baseUrl}/${messageId}/improve`, data);
  }

  updateImprovedResponse(messageId: string, data: PatchImprovedResponseRequest): Observable<void> {
    return this._http.patch<void>(`${this._baseUrl}/${messageId}/improve`, data);
  }

  deleteMessage(messageId: string): Observable<void> {
    return this._http.delete<void>(`${this._baseUrl}/${messageId}`);
  }
}
